import React from "react";
import "./App.css";
import AppRouter from "./components/AppRouter";

function App() {
  return (
    <React.Fragment id="app-container">
      <AppRouter />
    </React.Fragment>
  );
}

export default App;
